import React, { useState, useCallback, useEffect } from 'react';

import {
  Wrapper,
  Title,
  Container,
  Information,
  CircularCard,
  Icon,
  Text,
  IconCalendar,
  IconWhatsapp,
  IconChatBubbleLine,
  IconGroup,
  IconMailUnreadOutline,
  IconPhoneCall,
  IconFaQuestion,
} from './styles';
import { useHistory } from 'react-router-dom';

import SendEmailModal from '../../components/Modal/SendEmail';
import CallNowModal from '../../components/Modal/CallNow';
import ReceiveCallModal from '../../components/Modal/ReceiveCall';
import ScheduleCallModal from '../../components/Modal/ScheduleCall';
import SendWhatsappModal from '../../components/Modal/SendWhatsapp';
import SendMessageModal from '../../components/Modal/SendMessage';
import moment from 'moment';
import { useSelector } from 'react-redux';
import MessageOfAgendar from '../../components/Modal/InfoToModal/MessageOfAgendar';
import api from '../../services/api';
import { useDispatch } from 'react-redux';
import { navigationUrl } from '../../store/analytic/actions';

function Footer() {
  const history = useHistory();
  const dispatch = useDispatch();
  const config = useSelector((state: ApplicationState) => state.config);
  const [
    wppContact,
    setWppContact,
  ] = useState<GQL.ICreditorConfigPublicResponse | null>(null);
  const currentContract = useSelector(
    (state: ApplicationState) => state.contract.contractInformations
  );
  const { signed } = useSelector((state: ApplicationState) => {
    return {
      signed: state.auth.signed,
    };
  });

  const [modal, setModal] = useState({
    openReceiveCall: false,
    openScheduleCall: false,
    openCallNow: false,
    openSendEmail: false,
    openMessageOfAgendar: false,
    openSendMessage: false,
    openSendWhatsapp: false,
  });

  const handleOpenModal = useCallback(
    (type) => {
      if (type === 'openReceiveCall') {
        const toDayBegin =
          moment().day() === 6
            ? config.startSaturdayAttendance
            : config.startBusinessDayAttendance;
        const toEndDay =
          moment().day() === 6
            ? config.endSaturdayAttendance
            : config.endBusinessDayAttendance;
        if (
          moment().format('HH') >= toDayBegin &&
          moment().format('HH') <= toEndDay
        ) {
          setModal((prevState) => ({
            ...prevState,
            openReceiveCall: !prevState.openReceiveCall,
          }));
        } else {
          setModal((prevState) => ({
            ...prevState,
            openReceiveCall: false,
            openMessageOfAgendar: !prevState.openMessageOfAgendar,
          }));
        }
      }

      if (type === 'openScheduleCall') {
        setModal((prevState) => ({
          ...prevState,
          openScheduleCall: !prevState.openScheduleCall,
        }));
      }

      if (type === 'openCallNow') {
        setModal((prevState) => ({
          ...prevState,
          openCallNow: !prevState.openCallNow,
        }));
      }

      if (type === 'openSendMessage') {
        setModal((prevState) => ({
          ...prevState,
          openSendMessage: !prevState.openSendMessage,
        }));
      }

      if (type === 'openSendWhatsapp') {
        setModal((prevState) => ({
          ...prevState,
          openSendWhatsapp: !prevState.openSendWhatsapp,
        }));
      }

      if (type === 'openSendEmail') {
        setModal((prevState) => ({
          ...prevState,
          openSendEmail: !prevState.openSendEmail,
        }));
      }
    },
    [config]
  );

  const getWppByCreditorId = useCallback(async () => {
    if (!currentContract) return setWppContact(null);
    const { creditorId, databaseId } = currentContract;
    const wppRes = await api.getWppByCreditorId({
      creditorId: creditorId,
      credorDatabaseId: databaseId,
    });

    setWppContact(wppRes);
  }, [currentContract]);

  useEffect(() => {
    getWppByCreditorId();
  }, [currentContract, getWppByCreditorId]);

  const toWhatsappContact = useCallback(() => {
    const { whatsappContact: wpp, whatsappMessage: wppMessage } = config;
    const formattedWpp = (wppContact?.whatsapp || wpp).replace(/[()\-+ ]/g, '');
    const formattedWppMessage = wppMessage
      .replace(/#/g, '%23')
      .replace(/&/g, '%26');

    dispatch(
      navigationUrl.request({
        action: '/contatoWhatsApp',
      })
    );

    if (wppContact?.whatsapp || wpp)
      window.open(
        `https://wa.me/55${formattedWpp}?text=${formattedWppMessage}`
      );
  }, [config, wppContact, dispatch]);

  return (
    <Wrapper signed={signed}>
      <Container>
        <Title>Gostaria de falar conosco?</Title>
        <Information>
          {config.usaReceberLigacao === 'true' ? (
            <CircularCard onClick={() => handleOpenModal('openReceiveCall')}>
              <Icon>
                <IconGroup className='footer-icon' />
              </Icon>
              <Text>
                Receber uma ligação <span id='bold'>Agora</span>
              </Text>
            </CircularCard>
          ) : null}
          {config.usaAgendarLigacao === 'true' ? (
            <CircularCard onClick={() => handleOpenModal('openScheduleCall')}>
              <Icon>
                <IconCalendar className='footer-icon' />
              </Icon>
              <Text>
                <span id='bold'>Agendar</span> uma ligação
              </Text>
            </CircularCard>
          ) : null}
          {config.usaLigarAgora === 'true' ? (
            <CircularCard onClick={() => handleOpenModal('openCallNow')}>
              <Icon>
                <IconPhoneCall className='footer-icon' />
              </Icon>
              <Text>
                <span id='bold'>Ligar</span> agora
              </Text>
            </CircularCard>
          ) : null}
          {config.usaWhatsapp === 'true' ? (
            <CircularCard onClick={toWhatsappContact}>
              <Icon>
                <IconWhatsapp className='footer-icon' />
              </Icon>
              <Text>
                Contato por <span id='bold'>Whatsapp</span>
              </Text>
            </CircularCard>
          ) : null}
          {config.usaEnviarMensagem === 'true' ? (
            <CircularCard>
              <Icon>
                <IconChatBubbleLine className='footer-icon' />
              </Icon>
              <Text>
                Enviar uma <span id='bold'>Mensagem</span>
              </Text>
            </CircularCard>
          ) : null}
          {config.usaEnviarEmail === 'true' ? (
            <CircularCard onClick={() => handleOpenModal('openSendEmail')}>
              <Icon>
                <IconMailUnreadOutline className='footer-icon' />
              </Icon>
              <Text>
                Contato por <br id='break' />
                <span id='bold'>E-mail</span>
              </Text>
            </CircularCard>
          ) : null}
          {config.exibeFaq === 'true' ? (
            <CircularCard onClick={() => history.push('/faq')}>
              <Icon>
                <IconFaQuestion className='footer-icon' />
              </Icon>
              <Text>
                <span id='bold'>F.A.Q.</span>
              </Text>
            </CircularCard>
          ) : null}
        </Information>
      </Container>
      {modal.openSendEmail && (
        <SendEmailModal handlerClose={() => handleOpenModal('openSendEmail')} />
      )}
      {modal.openCallNow && (
        <CallNowModal handlerClose={() => handleOpenModal('openCallNow')} />
      )}
      {modal.openReceiveCall && (
        <ReceiveCallModal
          verification={''}
          handlerClose={() => handleOpenModal('openReceiveCall')}
        />
      )}
      {modal.openMessageOfAgendar && (
        <MessageOfAgendar
          verification={''}
          handlerClose={() => handleOpenModal('openReceiveCall')}
        />
      )}
      {modal.openScheduleCall && (
        <ScheduleCallModal
          verification={''}
          handlerClose={() => handleOpenModal('openScheduleCall')}
        />
      )}
      {modal.openSendWhatsapp && (
        <SendWhatsappModal
          handlerClose={() => handleOpenModal('openSendWhatsapp')}
        />
      )}
      {modal.openSendMessage && (
        <SendMessageModal
          handlerClose={() => handleOpenModal('openSendMessage')}
        />
      )}
    </Wrapper>
  );
}

export default Footer;
